/*
 * Copyright (c) 2025 curryfirm.com
 */

// workflowSelectors.js
import { createSelector } from 'reselect';
import {
    selectEmptyAvailableCans,
    selectStartLocation,
    selectEndLocation,
    selectChosenDumpsterIds,
    selectConfirmedDumpLocationIds,
} from './workflowSlice.js';
import { selectDumpstersAtLot } from '../dumpsters/dumpstersSlice.js';
import { selectAllLocations } from '../locations/locationsSlice.js';
import { selectAllDumpsters } from '../dumpsters/dumpstersSlice.js';
import { selectAllDumps } from '../dumps/dumpsSlice.js';

export const selectConfirmedDumpDetails = createSelector(
    [selectConfirmedDumpLocationIds, selectAllDumps],
    (confirmedDumpIds, allDumps) =>
        allDumps.filter(d => confirmedDumpIds.includes(d.locationId))
);

export const selectEmptyAvailableDumpsterDetails = createSelector(
    [selectEmptyAvailableCans, selectDumpstersAtLot],
    (emptyAvailableCanIds, lotDumpsters) =>
        lotDumpsters.filter(d => emptyAvailableCanIds.includes(d.dumpsterId))
);

export const selectStartLocationDetails = createSelector(
    [selectStartLocation, selectAllLocations ],
    (id, locs) => locs.find(l => l.key === id)
);

export const selectEndLocationDetails = createSelector(
    [selectEndLocation, selectAllLocations ],
    (id, locs) => locs.find(l => l.key === id)
);

export const selectChosenDumpsterDetails = createSelector(
    [selectChosenDumpsterIds, selectAllDumpsters ],
    (ids, allDumpsters) =>
        allDumpsters.filter(d => ids.includes(d.dumpsterId))
);